export default __webpack_public_path__ + "static/media/bg-blur.b5987635.png";